import { v4 as uuid } from 'uuid';

import { MESSAGES, ROLE } from '../../../constants';

export type ArticleVideo = Readonly<{
  url: string;
  duration?: string;
}>;

export type IAIArticleAnswerItem = Readonly<{
  articleId: string;
  title: string;
  url: string;
  description?: string;
  videos?: ArticleVideo[];
}>;

const normalizeVideo = (video: string | ArticleVideo): ArticleVideo =>
  typeof video === 'string' ? { url: video } : { url: video.url, duration: video.duration };

export interface IAIArticleAnswer {
  readonly id: string;
  readonly nodeId: string;
  readonly type: MESSAGES.AI_ARTICLE_ANSWER;
  readonly answer: string;
  readonly articles: IAIArticleAnswerItem[];
  readonly rm: boolean;
  readonly role: ROLE;
  readonly preventScroll: boolean;
  readonly isStreaming?: boolean;
  readonly isCancelled?: boolean;
}

// max number of articles we show under this message
const ARTICLES_LIMIT = 3;

export const createAIArticleAnswer = (data): IAIArticleAnswer => ({
  id: data.id || uuid(),
  nodeId: data.nodeId,
  type: MESSAGES.AI_ARTICLE_ANSWER,
  answer: data.answer,
  articles: data.articles
    .map((article) => ({
      articleId: article.articleId,
      title: article.title,
      url: article.url,
      description: article.description,
      videos: (article.articleVideos ?? []).map(normalizeVideo),
    }))
    .slice(0, ARTICLES_LIMIT),
  rm: Boolean(data.rm),
  preventScroll: Boolean(data.preventScroll),
  role: ROLE.BOT,
});
